const changeProfilePictureStr = {
  toastr: 'Foto de perfil cambiada',
  toastr1: 'Foto de perfil cambiada con éxito'
};

export default changeProfilePictureStr;
